import axios from 'axios'

/** Path is /tv-app-schedule, not /tv-app/schedule - see TvAppScheduleController. */
export default {
  getSchedules: (placeId) => axios.get(`/api/v1/tv-app-schedule/place/${placeId}`),
  createSchedule: (placeId, data) => axios.post(`/api/v1/tv-app-schedule/place/${placeId}`, data),
  getSchedule: (scheduleId) => axios.get(`/api/v1/tv-app-schedule/${scheduleId}`),
  updateSchedule: (scheduleId, data) => axios.patch(`/api/v1/tv-app-schedule/${scheduleId}`, data),
  removeSchedule: (scheduleId) => axios.delete(`/api/v1/tv-app-schedule/${scheduleId}`),
  addWindow: (scheduleId, data) => axios.post(`/api/v1/tv-app-schedule/${scheduleId}/window`, data),
  updateWindow: (scheduleId, windowId, data) => axios.put(`/api/v1/tv-app-schedule/${scheduleId}/window/${windowId}`, data),
  removeWindow: (scheduleId, windowId) => axios.delete(`/api/v1/tv-app-schedule/${scheduleId}/window/${windowId}`),
  addException: (scheduleId, data) => axios.post(`/api/v1/tv-app-schedule/${scheduleId}/exception`, data),
  removeException: (scheduleId, exceptionId) => axios.delete(`/api/v1/tv-app-schedule/${scheduleId}/exception/${exceptionId}`),
  setDevices: (scheduleId, macs) => axios.put(`/api/v1/tv-app-schedule/${scheduleId}/devices`, { macs })
}
